import React from "react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components";
import { inventoryReportsList } from "./reportConfig";

export const InventoryReports: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 min-h-screen bg-gray-50">
      <PageHeader
        handleButtons={[]}
        title="Inventory & Purchase Reports"
        subText="Audit stock valuations, check expiring batches, and track inbound supplier procurement logs."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
        {inventoryReportsList.map((item, idx) => {
          const IconComponent = item.icon;
          return (
            <Card
              key={idx}
              hoverable
              onClick={() => navigate(`../${item.path}`)}
              className={`border border-2 rounded-2xl shadow-lg transition-all duration-200 hover:-translate-y-1 hover:shadow-md ${item.bgColor}`}
            >
              <div className="flex items-start gap-4">
                <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100">
                  <IconComponent className={`w-6 h-6 ${item.iconColor}`} />
                </div>
                <div className="flex flex-col gap-1.5">
                  <h3 className="font-bold text-gray-800 text-sm">
                    {item.name}
                  </h3>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
